import React, { createContext, useContext } from 'react';

export type Theme = 'light' | 'dark';

export const ThemeContext = createContext<Theme>('light');

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider: React.FC<{ value: Theme; children: React.ReactNode }> = ({ value, children }) => {
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};
